import type { SortCriteria } from '@/contexts/products/ProductsContext'
import { VpIcon, VpIconButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { getSortOrderIcon } from '@/components/ProductsHeader/utils'
import { SortDropdown } from '@/components/SortDropdown/SortDropdown'
import { SORT_CRITERIA } from '@/contexts/products/ProductsContext'
import { useProductsContext } from '@/contexts/products/useProductsContext'

export function ProductsViewHeaderSortControl() {
  const { t } = useTranslation()
  const {
    customViewTarget,
    onSortCriteria,
    sortCriteria,
    sortOrder,
    sortOrderChosen,
    toggleSortOrder,
    viewMode,
  } = useProductsContext()

  const isGallery = customViewTarget === 'gallery'
  const disabledCriteria: SortCriteria[]
    = isGallery && viewMode === 'sm' ? ['customer-rating' as SortCriteria] : []

  return (
    <div className="products-view-header__sort">
      <SortDropdown
        criteria={SORT_CRITERIA}
        disabledCriteria={disabledCriteria}
        selectedCriteria={sortCriteria}
        onSelect={onSortCriteria}
      />
      <VpIconButton
        aria-label={t('aria-label.toggle-sort-order')}
        variant="secondary"
        size="small"
        onClick={toggleSortOrder}
      >
        <VpIcon name={getSortOrderIcon(sortOrderChosen, sortOrder)} />
      </VpIconButton>
    </div>
  )
}
